// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X8jz","input":"styles_input__2Jh6M"};